/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/scrollbar";
import "swiper/css/effect-fade";
import "swiper/css/effect-flip";
import { Pagination, Autoplay } from "swiper";
import { useState, useEffect } from "react";
import { Card, CardBody, CardFooter, CardHeader, Col, Input, Row } from 'reactstrap';
import config from "../../../common/config";

const CarsInfoList = ({ selectedCar, extraHours, isEdit, carId, setCarId, activeTab, babySeats, isBookingSuccess }) => {
    const [isAcitve, setIsActive] = React.useState(false);
    const [id, setId] = useState(false);
    const [carDetails, setCarDetails] = useState("");
    const [pageNumber, setPageNumber] = useState(1);
    const [car, setCar] = useState("");
    const [selectedSeats, setSelectedSeats] = useState("");
    const [currentActiveTab, setCurrentActiveTab] = useState(activeTab);

    useEffect(() => {
        fetchCars();
    }, [selectedSeats]);

    // Keep currentActiveTab in sync whenever activeTab prop changes
    useEffect(() => {
        setCurrentActiveTab(activeTab);
    }, [activeTab]);

    useEffect(() => {
        if (carDetails) {
            setIsActive(carId);
        }
    }, [carId, carDetails]);

    useEffect(() => {
        const carBrandAndModel = getCarById(isAcitve);
        setCar(carBrandAndModel);
    }, [isAcitve]);

    useEffect(() => {
        setSelectedSeats(extraHours + babySeats);
    }, [extraHours, babySeats, isAcitve]);

    useEffect(() => {
        const carListArray = Object.values(carDetails);
        const filteredCarListArray = carListArray.filter((car) => car.status === 1);

        const carsWithSeatsSingapore = filteredCarListArray
            .filter((car) => car.singapore_disposal_per_hours !== 0)
            .filter((car) => car.seat_capacity >= selectedSeats);

        const carsWithSeatsMalaysia = filteredCarListArray
            .filter((car) => car.malaysia_disposal_per_hours !== 0)
            .filter((car) => car.seat_capacity >= selectedSeats);

        const carsWithSeatsDeparture = filteredCarListArray
            .filter((car) => car.airport_departure !== 0)
            .filter((car) => car.seat_capacity >= selectedSeats);

        const carsWithSeatsArrival = filteredCarListArray
            .filter((car) => car.airport_arrival !== 0)
            .filter((car) => car.seat_capacity >= selectedSeats);

        if (activeTab === "4" && carsWithSeatsSingapore.length === 0) {
            setCarId('');
        } else if (activeTab === "5" && carsWithSeatsMalaysia.length === 0) {
            setCarId('');
        } else if (activeTab === "2" && carsWithSeatsDeparture.length === 0) {
            setCarId('');
        } else if (activeTab === "1" && carsWithSeatsArrival.length === 0) {
            setCarId('');
        }
    }, [carDetails, activeTab]);

    const getCarById = (carId) => {
        const carListArray = Object.values(carDetails);
        const car = carListArray.find((carObj) => carObj._id === carId);
        return car ? car : null;
    };

    const handleCarSelection = (carId) => {
        setIsActive((prevCarId) => (prevCarId === carId ? false : carId));
    };

    const fetchCars = async () => {
        const hotelId = localStorage.getItem("hotelid");

        await fetch(config.baseUrl + `api/admin/carlist?hotel_id=${hotelId}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                page: pageNumber,
                limit: "all",
            }),
        })
            .then((response) => response.json())
            .then((data) => {
                setCarDetails(data.data);
            });
    };

    const carListArray = Object.values(carDetails);
    const filteredCarListArray = carListArray.filter((car) => car.status === 1);

    selectedCar(car);

    const carsWithSeats = filteredCarListArray
        .filter((car) => car.malaysia_disposal_per_hours !== 0)
        .filter((car) => car.seat_capacity >= selectedSeats);

    const carsNotavailable = filteredCarListArray.filter((car) => car.malaysia_disposal_per_hours !== 0);

    const carsWithSeatsArrival = filteredCarListArray
        .filter((car) => (activeTab === "2" ? car.airport_departure !== 0 : car.airport_arrival !== 0))
        .filter((car) => car.seat_capacity >= selectedSeats);

    const carsNotavailableForArrival = filteredCarListArray.filter((car) => 
        activeTab === "2" ? car.airport_departure !== 0 : car.airport_arrival !== 0
    );

    const carsNotavailableForSingapore = filteredCarListArray.filter((car) => car.singapore_disposal_per_hours !== 0);
    const carsWithSeatsSingapore = carsNotavailableForSingapore.filter((car) => car.seat_capacity >= selectedSeats);

    // Calculate dynamic price based on the selected tab
    const calculatePrice = (car) => {
        const tab = activeTab || currentActiveTab;
        if (tab === "4") {
            return car.singapore_disposal_per_hours;
        } else if (tab === "5") {
            return car.malaysia_disposal_per_hours;
        } else if (tab === "2") {
            return car.airport_departure || car.airport_arrival;
        } else if (tab === "3") {
            return car.point_to_point;
        } else {
            return car.airport_arrival;
        }
    };

    return (
        <React.Fragment>
            <div>
                <h5 className="mb-0">Cars Info</h5>
                <p className="text-muted mt-0">Fill all information below</p>
            </div>

            {/* Singapore Tab */}
            {activeTab === "4" && (
                carsWithSeatsSingapore.length > 0 ? (
                    <Row>
                        {carsWithSeatsSingapore.map((item, i) => (
                            <Col md={6} lg={4} xl={3} key={i}>
                                <Card className={`card-car-info ${isAcitve === item._id ? 'active-card' : ''}`}>
                                    <CardHeader className='bg-light border-1 align-items-center d-flex justify-content-between py-2'>
                                        <h4 className="card-title mb-0 fs-13">{item.car_brand} - {item.car_model}</h4>
                                        <div className="flex-shrink-0 align-items-center">
                                            <div className="form-check form-switch form-switch-right mt-2 me-2">
                                                <Input className="form-check-input code-switcher" type="checkbox" role="switch" id={item._id} name='carInfo' checked={isAcitve === item._id} onChange={() => handleCarSelection(item._id)} />
                                            </div>
                                        </div>
                                    </CardHeader>
                                    <CardBody className='p-0'>
                                        <Swiper pagination={{ clickable: true, dynamicBullets: true }} modules={[Pagination, Autoplay]} loop={true} autoplay={{ delay: 2500, disableOnInteraction: false }} className="swiper pagination-dynamic-swiper dynamic-pagination rounded">
                                            <div className="swiper-wrapper">
                                                {item.car_photos.map((sliderItem, i) => (
                                                    <SwiperSlide key={i}><img src={config.baseUrl + sliderItem} alt="" className="img-fluid" /></SwiperSlide>
                                                ))}
                                            </div>
                                        </Swiper>
                                        <div className="p-2 row">
                                            <div className="col-6">
                                                <p className="text-muted mb-0 mt-0">Price</p>
                                                <h3 className="card-title mb-0 fs-17">${calculatePrice(item)}</h3>
                                            </div>
                                            <div className="col-6 text-end">
                                                <p className="text-muted mb-0 mt-0">Seat Capacity</p>
                                                <h3 className="card-title mb-0 fs-17">{item.seat_capacity}</h3>
                                            </div>
                                        </div>
                                    </CardBody>
                                    <CardFooter className='bg-light border-top-dashed py-2'>
                                        <div className="flex-grow-1">
                                            <h5 className="mb-1 fs-14">Car Details</h5>
                                        </div>
                                    </CardFooter>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                ) : (
                    <Row>
                        {carsNotavailableForSingapore.map((item, i) => (
                            <Col md={6} lg={4} xl={3} key={i}>
                                <Card className={`card-car-info ${isAcitve === item._id ? 'active-card' : ''}`}>
                                    <CardHeader className='bg-light border-1 align-items-center d-flex justify-content-between py-2'>
                                        <h4 className="card-title mb-0 fs-13">{item.car_brand} - {item.car_model}</h4>
                                        <div className="flex-shrink-0 align-items-center">
                                            <div className="form-check form-switch form-switch-right mt-2 me-2">
                                                <Input className="form-check-input code-switcher" type="checkbox" role="switch" id={item._id} name='carInfo' checked={isAcitve === item._id} onChange={() => handleCarSelection(item._id)} />
                                            </div>
                                        </div>
                                    </CardHeader>
                                    <CardBody className='p-0'>
                                        <Swiper pagination={{ clickable: true, dynamicBullets: true }} modules={[Pagination, Autoplay]} loop={true} autoplay={{ delay: 2500, disableOnInteraction: false }} className="swiper pagination-dynamic-swiper dynamic-pagination rounded">
                                            <div className="swiper-wrapper">
                                                {item.car_photos.map((sliderItem, i) => (
                                                    <SwiperSlide key={i}><img src={config.baseUrl + sliderItem} alt="" className="img-fluid" /></SwiperSlide>
                                                ))}
                                            </div>
                                        </Swiper>
                                        <div className="p-2 row">
                                            <div className="col-6">
                                                <p className="text-muted mb-0 mt-0">Price</p>
                                                <h3 className="card-title mb-0 fs-17">${calculatePrice(item)}</h3>
                                            </div>
                                            <div className="col-6 text-end">
                                                <p className="text-muted mb-0 mt-0">Seat Capacity</p>
                                                <h3 className="card-title mb-0 fs-17">{item.seat_capacity}</h3>
                                            </div>
                                        </div>
                                    </CardBody>
                                    <CardFooter className='bg-light border-top-dashed py-2'>
                                        <div className="flex-grow-1">
                                            <h5 className="mb-1 fs-14">Car Details</h5>
                                        </div>
                                    </CardFooter>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                )
            )}

            {/* Malaysia Tab */}
            {activeTab === "5" && (
                carsWithSeats.length > 0 ? (
                    <Row>
                        {carsWithSeats.map((item, i) => (
                            <Col md={6} lg={4} xl={3} key={i}>
                                <Card className={`card-car-info ${isAcitve === item._id ? 'active-card' : ''}`}>
                                    <CardHeader className='bg-light border-1 align-items-center d-flex justify-content-between py-2'>
                                        <h4 className="card-title mb-0 fs-13">{item.car_brand} - {item.car_model}</h4>
                                        <div className="flex-shrink-0 align-items-center">
                                            <div className="form-check form-switch form-switch-right mt-2 me-2">
                                                <Input className="form-check-input code-switcher" type="checkbox" role="switch" id={item._id} name='carInfo' checked={isAcitve === item._id} onChange={() => handleCarSelection(item._id)} />
                                            </div>
                                        </div>
                                    </CardHeader>
                                    <CardBody className='p-0'>
                                        <Swiper pagination={{ clickable: true, dynamicBullets: true }} modules={[Pagination, Autoplay]} loop={true} autoplay={{ delay: 2500, disableOnInteraction: false }} className="swiper pagination-dynamic-swiper dynamic-pagination rounded">
                                            <div className="swiper-wrapper">
                                                {item.car_photos.map((sliderItem, i) => (
                                                    <SwiperSlide key={i}><img src={config.baseUrl + sliderItem} alt="" className="img-fluid" /></SwiperSlide>
                                                ))}
                                            </div>
                                        </Swiper>
                                        <div className="p-2 row">
                                            <div className="col-6">
                                                <p className="text-muted mb-0 mt-0">Price</p>
                                                <h3 className="card-title mb-0 fs-17">${calculatePrice(item)}</h3>
                                            </div>
                                            <div className="col-6 text-end">
                                                <p className="text-muted mb-0 mt-0">Seat Capacity</p>
                                                <h3 className="card-title mb-0 fs-17">{item.seat_capacity}</h3>
                                            </div>
                                        </div>
                                    </CardBody>
                                    <CardFooter className='bg-light border-top-dashed py-2'>
                                        <div className="flex-grow-1">
                                            <h5 className="mb-1 fs-14">Car Details</h5>
                                        </div>
                                    </CardFooter>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                ) : (
                    <Row>
                        {carsNotavailable.map((item, i) => (
                            <Col md={6} lg={4} xl={3} key={i}>
                                <Card className={`card-car-info ${isAcitve === item._id ? 'active-card' : ''}`}>
                                    <CardHeader className='bg-light border-1 align-items-center d-flex justify-content-between py-2'>
                                        <h4 className="card-title mb-0 fs-13">{item.car_brand} - {item.car_model}</h4>
                                        <div className="flex-shrink-0 align-items-center">
                                            <div className="form-check form-switch form-switch-right mt-2 me-2">
                                                <Input className="form-check-input code-switcher" type="checkbox" role="switch" id={item._id} name='carInfo' checked={isAcitve === item._id} onChange={() => handleCarSelection(item._id)} />
                                            </div>
                                        </div>
                                    </CardHeader>
                                    <CardBody className='p-0'>
                                        <Swiper pagination={{ clickable: true, dynamicBullets: true }} modules={[Pagination, Autoplay]} loop={true} autoplay={{ delay: 2500, disableOnInteraction: false }} className="swiper pagination-dynamic-swiper dynamic-pagination rounded">
                                            <div className="swiper-wrapper">
                                                {item.car_photos.map((sliderItem, i) => (
                                                    <SwiperSlide key={i}><img src={config.baseUrl + sliderItem} alt="" className="img-fluid" /></SwiperSlide>
                                                ))}
                                            </div>
                                        </Swiper>
                                        <div className="p-2 row">
                                            <div className="col-6">
                                                <p className="text-muted mb-0 mt-0">Price</p>
                                                <h3 className="card-title mb-0 fs-17">${calculatePrice(item)}</h3>
                                            </div>
                                            <div className="col-6 text-end">
                                                <p className="text-muted mb-0 mt-0">Seat Capacity</p>
                                                <h3 className="card-title mb-0 fs-17">{item.seat_capacity}</h3>
                                            </div>
                                        </div>
                                    </CardBody>
                                    <CardFooter className='bg-light border-top-dashed py-2'>
                                        <div className="flex-grow-1">
                                            <h5 className="mb-1 fs-14">Car Details</h5>
                                        </div>
                                    </CardFooter>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                )
            )}

            {/* Arrival & Departure Tabs ("1", "2", or other default tabs) */}
            {activeTab !== "4" && activeTab !== "5" && (
                selectedSeats > 0 ? (
                    <Row>
                        {carsWithSeatsArrival.map((item, i) => (
                            <Col md={6} lg={4} xl={3} key={i}>
                                <Card className={`card-car-info ${isAcitve === item._id ? 'active-card' : ''}`}>
                                    <CardHeader className='bg-light border-1 align-items-center d-flex justify-content-between py-2'>
                                        <h4 className="card-title mb-0 fs-13">{item.car_brand} - {item.car_model}</h4>
                                        <div className="flex-shrink-0 align-items-center">
                                            <div className="form-check form-switch form-switch-right mt-2 me-2">
                                                <Input className="form-check-input code-switcher" type="checkbox" role="switch" id={item._id} name='carInfo' checked={isAcitve === item._id} onChange={() => handleCarSelection(item._id)} />
                                            </div>
                                        </div>
                                    </CardHeader>
                                    <CardBody className='p-0'>
                                        <Swiper pagination={{ clickable: true, dynamicBullets: true }} modules={[Pagination, Autoplay]} loop={true} autoplay={{ delay: 2500, disableOnInteraction: false }} className="swiper pagination-dynamic-swiper dynamic-pagination rounded">
                                            <div className="swiper-wrapper">
                                                {item.car_photos.map((sliderItem, i) => (
                                                    <SwiperSlide key={i}><img src={config.baseUrl + sliderItem} alt="" className="img-fluid" /></SwiperSlide>
                                                ))}
                                            </div>
                                        </Swiper>
                                        <div className="p-2 row">
                                            <div className="col-6">
                                                <p className="text-muted mb-0 mt-0">Price</p>
                                                <h3 className="card-title mb-0 fs-17">${calculatePrice(item)}</h3>
                                            </div>
                                            <div className="col-6 text-end">
                                                <p className="text-muted mb-0 mt-0">Seat Capacity</p>
                                                <h3 className="card-title mb-0 fs-17">{item.seat_capacity}</h3>
                                            </div>
                                        </div>
                                    </CardBody>
                                    <CardFooter className='bg-light border-top-dashed py-2'>
                                        <div className="flex-grow-1">
                                            <h5 className="mb-1 fs-14">Car Details</h5>
                                        </div>
                                    </CardFooter>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                ) : (
                    <Row>
                        {carsNotavailableForArrival.map((item, i) => (
                            <Col md={6} lg={4} xl={3} key={i}>
                                <Card className={`card-car-info ${isAcitve === item._id ? 'active-card' : ''}`}>
                                    <CardHeader className='bg-light border-1 align-items-center d-flex justify-content-between py-2'>
                                        <h4 className="card-title mb-0 fs-13">{item.car_brand} - {item.car_model}</h4>
                                        <div className="flex-shrink-0 align-items-center">
                                            <div className="form-check form-switch form-switch-right mt-2 me-2">
                                                <Input className="form-check-input code-switcher" type="checkbox" role="switch" id={item._id} name='carInfo' checked={isAcitve === item._id} onChange={() => handleCarSelection(item._id)} />
                                            </div>
                                        </div>
                                    </CardHeader>
                                    <CardBody className='p-0'>
                                        <Swiper pagination={{ clickable: true, dynamicBullets: true }} modules={[Pagination, Autoplay]} loop={true} autoplay={{ delay: 2500, disableOnInteraction: false }} className="swiper pagination-dynamic-swiper dynamic-pagination rounded">
                                            <div className="swiper-wrapper">
                                                {item.car_photos.map((sliderItem, i) => (
                                                    <SwiperSlide key={i}><img src={config.baseUrl + sliderItem} alt="" className="img-fluid" /></SwiperSlide>
                                                ))}
                                            </div>
                                        </Swiper>
                                        <div className="p-2 row">
                                            <div className="col-6">
                                                <p className="text-muted mb-0 mt-0">Price</p>
                                                <h3 className="card-title mb-0 fs-17">${calculatePrice(item)}</h3>
                                            </div>
                                            <div className="col-6 text-end">
                                                <p className="text-muted mb-0 mt-0">Seat Capacity</p>
                                                <h3 className="card-title mb-0 fs-17">{item.seat_capacity}</h3>
                                            </div>
                                        </div>
                                    </CardBody>
                                    <CardFooter className='bg-light border-top-dashed py-2'>
                                        <div className="flex-grow-1">
                                            <h5 className="mb-1 fs-14">Car Details</h5>
                                        </div>
                                    </CardFooter>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                )
            )}
        </React.Fragment>
    );
};

export default CarsInfoList;